import { Button } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import { ATTESTATIONS_MANAGEMENT, STUDENT_EDUCATION, StudentServicePath } from "utils/constants";

const ManageAttestationsButton = ({ record }) => {
  const navigate = useNavigate();

  if (!record?.id) return null;

  const studentName = [record?.userInfo?.firstName, record?.userInfo?.secondName, record?.userInfo?.lastName]
    .filter(Boolean)
    .join(" ");

  return (
    <SecuredComponent permission={permissions.canPreviewStudentEducationAttestations}>
      <Button
        label="Управление на заверки"
        variant="contained"
        size="small"
        startIcon={<EditIcon />}
        onClick={() =>
          navigate(`/${StudentServicePath}${STUDENT_EDUCATION}/${record.id}/${ATTESTATIONS_MANAGEMENT}`, {
            state: {
              studentName,
              facultyNumber: record?.facultyNumber,
              curriculumName: record?.curriculumName,
              course: record?.course,
            },
          })
        }
      />
    </SecuredComponent>
  );
};

export default ManageAttestationsButton;
